import DelegatesForm from './delegatesForm';
import ViewDelegate from './viewDelegate';
import EditLocationPermissionListing from './editLocationPermissionListing';
import EditDelegate from './editDelegate';
import DeleteDelegate from './deleteDelegate';

export { ViewDelegate, EditLocationPermissionListing, EditDelegate, DeleteDelegate };
export default DelegatesForm;